import { cn } from '@/lib/utils';
import { trpc } from '../../lib/trpc';

export function useInboxCount() {
  return trpc.transaction.inboxCount.useQuery(undefined, {
    staleTime: 60_000,
  }).data;
}

export function InboxBadge({
  count,
  className,
}: {
  count: number | undefined;
  className?: string;
}) {
  if (!count) return null;
  return (
    <span
      className={cn(
        'inline-flex min-w-5 items-center justify-center rounded-full bg-warning px-1.5 text-[11px] font-semibold leading-5 text-background tabular-nums',
        className,
      )}
    >
      <span className="sr-only">Att sortera: </span>
      {count > 99 ? '99+' : count}
    </span>
  );
}
